<template>
	<section v-if="item"
			 ref="imagesSectionRef"
			 class="flex-module container-fluid flexible-videos">

		<div class="row">
			<div class="flexible-images-wrapper"
				 :class="containerWidthClasses">
				<div v-for="{ video } in item.videos"
					 :key="video.id"
					 class="flexible-image-entry">

					<figure>
						<div class="video-wrapper">
							<BaseVideo :data="video"
									   :disable-cast-icon="true"
									   preload
									   autoplay
									   loop
									   muted
									   playsinline />
						</div>
						<figcaption v-if="video?.text"
									class="details"
									v-html="video?.text" />
					</figure>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
	sizes: {
		type: String,
		default: '100vw',
	},
	trigger: {
		type: String,
		default: 'hover',
	},
})

const item = computed(() => props.data?.item)

const containerWidthClasses = computed(() => {
	if (!item.value) return

	let string = ''

	if (item.value.alignment === 'fullWidth') {
		string = 'col-xs-12'
	} else {
		string = 'col-xs-12 col-sm-8 col-md-6 vertical'
		if (item.value.alignment === 'right') string = string + ' col-sm-offset-4 col-md-offset-6'
	}

	return string
})
</script>

<style lang="scss" scoped>
.flexible-images-wrapper {
	display: flex;
	gap: calc($half-gutter-width * 2);

	.flexible-image-entry {
		width: 100%;

		&:last-of-type {
			margin-right: 0;
		}

		figure {
			width: 100%;

			.video-wrapper {
				@include rounded-corners;

				video {
					width: 100%;
				}
			}
		}
	}

	@include for-devices-below(md) {
		flex-direction: column;
	}

	&.vertical {
		flex-direction: column;

	}
}

.details {
	@include textDetails;
	color: var(--details-color, $black);
}
</style>
